function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e30512;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M42.52,21.26c0,11.74-9.52,21.26-21.26,21.26S0,33,0,21.26,9.52,0,21.26,0s21.26,9.52,21.26,21.26"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M7.47,32.45c0-5.68,4.62-10.3,10.3-10.3h24.73c.01-.3.02-.6.02-.89s-.01-.6-.02-.89h-24.73c-5.68,0-10.3-4.62-10.3-10.3v-4.98C2.9,8.99,0,14.78,0,21.26s2.9,12.27,7.47,16.17v-4.98Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M19.74,13.69c-3.08,0-5.59-2.51-5.59-5.59V1.22c-.57.2-1.13.43-1.68.68v7.23c0,3.44,2.8,6.23,6.24,6.23h22.98c-.16-.57-.35-1.13-.56-1.68h-21.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M15.76,8.1c0,2.19,1.78,3.97,3.97,3.97h20.7C37.01,4.93,29.71,0,21.26,0c-1.9,0-3.74.25-5.5.72v7.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M17.77,18.75h24.6c-.07-.6-.16-1.19-.28-1.77h-23.38c-4.33,0-7.85-3.52-7.85-7.85V2.72c-.61.34-1.2.71-1.77,1.12v6.23c0,4.79,3.9,8.68,8.68,8.68"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M19.74,30.45c-2.19,0-3.97,1.78-3.97,3.97v7.38c1.75.47,3.6.72,5.5.72,8.45,0,15.75-4.93,19.18-12.07h-20.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M19.74,28.83h21.39c.21-.55.39-1.11.56-1.68h-22.98c-3.44,0-6.24,2.8-6.24,6.24v7.22c.55.25,1.11.48,1.68.68v-6.88c0-3.08,2.51-5.59,5.59-5.59"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M17.77,23.77c-4.79,0-8.68,3.89-8.68,8.68v6.23c.57.4,1.16.77,1.77,1.12v-6.41c0-4.33,3.52-7.85,7.85-7.85h23.38c.12-.58.21-1.17.28-1.77h-24.6Z"
})));

var SvgOm = function SvgOm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OM.529a57d4.svg";
export { ForwardRef as ReactComponent };